import { db } from "./firebase-init";
import { getBits } from "../utils/localStorage";
const bits = getBits();
const accessoriesCollection = db.collection(process.env.VUE_APP_WINE + bits);

export function getAccessories(filter, limit, after, orderBy, orderType) {
  let query = accessoriesCollection
    .where("tags", "array-contains", "Phụ kiện")
    .where("productId", ">", after)
    .orderBy(orderBy, orderType)
    .limit(limit);
  if (filter.name !== "") {
    query = query.where("name", "==", filter.name);
  } else if (filter.type !== "") {
    if (filter.type == "Chưa phân loại") {
      query = query.where("type", "array-contains", "");
    } else {
      query = query.where("type", "array-contains", filter.type);
    }
  }
  return query.get();
}

export function getAllAccessories() {
  return accessoriesCollection
    .where("tags", "array-contains", "Phụ kiện")
    .get();
}

export function removeAccessory(id) {
  return accessoriesCollection.doc(id).delete();
}

export function updateAccessory(item) {
  return accessoriesCollection.doc(item.id).update(item.data);
}

export function addAccessory(ref, accessory) {
  return ref.set(accessory);
}

export function getAccessoriesByName(name) {
  return accessoriesCollection
    .where("tags", "array-contains", "Phụ kiện")
    .where("name", "==", name)
    .get();
}
